"use strict";

/**
 * @namespace
 */
gc.gis.geom = gc.gis.geom || {};

/**
 * Geometry-Typen.
 *
 * @enum {string}
 */
gc.gis.geom.GCGeometryType = {

    POINT:              'Point',
    LINESTRING:         'LineString',
    LINEARRING:         'LinearRing',
    POLYGON:            'Polygon',
    RECTANGLE:          'Rectangle',
    BOX:                'Box',
	CIRCLE:             'Circle',
    MULTIPOINT:         'MultiPoint',
    MULTILINE:          'MultiLineString',
    MULTIPOLYGON:       'MultiPolygon',
    GEOMETRYCOLLECTION: 'GeometryCollection'
};


/**
 * @classdesc
 * Abstrakte Wrapperklasse für Geometrieobjekte.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} geometry gewrappte Geometrie-Instanz
 */
gc.gis.geom.GCGeometry = function(geometry)
{
    gc.gis.GCWrappable.call(this);

    this._geom = geometry;
};
gc.gis.geom.GCGeometry.prototype = Object.create(gc.gis.GCWrappable.prototype);


/**
 * @inheritdoc
 */
gc.gis.geom.GCGeometry.prototype.getImpl = function()
{
    return this._geom;
};

/**
 * Gibt das CRS der Geometrie zurück.
 *
 * @method
 * @return {string} CRS
 * @public
 */
gc.gis.geom.GCGeometry.prototype.getCRS = gc.gis.abstractMethod;

/**
 * Setzt das CRS der Geometrie.
 *
 * @method
 * @param {string} crs CRS
 * @return {gc.gis.geom.GCGeometry}
 * @public
 */
gc.gis.geom.GCGeometry.prototype.setCRS = gc.gis.abstractMethod;

/**
 * Projeziert die Geometrie in das angegebene CRS.
 *
 * @method
 * @param {string} crs
 * @public
 */
gc.gis.geom.GCGeometry.prototype.project = gc.gis.abstractMethod;

/**
 * Gibt den Geometrietyp zurück.
 *
 * @abstract
 * @method
 * @public
 * @return {gc.gis.geom.GCGeometryType} Geometrietyp
 */
gc.gis.geom.GCGeometry.prototype.getType = gc.gis.abstractMethod;

/**
 * Gibt das Umgebungsrechteck zurück.
 *
 * @abstract
 * @method
 * @public
 * @return {gc.gis.map.GCMapExtent}	Ausdehnung [minx, miny, maxx, maxy]
 */
gc.gis.geom.GCGeometry.prototype.getExtent = gc.gis.abstractMethod;

/**
 * Erzeugt ein einzelnes Geometrieobjekt anhand der übergebenen Geometrieliste.
 *
 * @public
 * @param {gc.gis.geom.GCGeometry[]} geometries
 */
gc.gis.geom.GCGeometry.fromGeometryList = function (geometries)
{
    // TODO weitermachen
    var geom,
        geom2,
        factory = gc.gis.iface.mapFactory,
        points = [],
        lines = [],
        polygons = [],
        i, ii,
        j, jj;

    for (i = 0, ii = geometries.length; i < ii;  i++)
    {
        geom = geometries[i];
        switch (geom.getType())
        {
            case gc.gis.geom.GCGeometryType.POINT:
                points.push(geom);
                break;
            case gc.gis.geom.GCGeometryType.LINESTRING:
            case gc.gis.geom.GCGeometryType.LINEARRING:
                lines.push(geom);
                break;
            case gc.gis.geom.GCGeometryType.POLYGON:
                polygons.push(geom);
                break;
            case gc.gis.geom.GCGeometryType.MULTIPOINT:
                for (j = 0, jj = geom.numPoints(); j < jj;  j++)
                {
                    points.push(geom.getPoint(j));
                }
                break;
            case gc.gis.geom.GCGeometryType.MULTILINE:
                for (j = 0, jj = geom.numLineStrings(); j < jj;  j++)
                {
                    lines.push(geom.getLineString(j));
                }
                break;
            case gc.gis.geom.GCGeometryType.MULTIPOLYGON:
                for (j = 0, jj = geom.numPolygons(); j < jj;  j++)
                {
                    polygons.push(geom.getPolygon(j));
                }
                break;
            case gc.gis.geom.GCGeometryType.GEOMETRYCOLLECTION:
                for (j = 0, jj = geom.numGeometries(); j < jj;  j++)
                {
                    geom2 = geom.getGeometry(j);
                    switch (geom2.getType())
                    {
                        case gc.gis.geom.GCGeometryType.POINT:
                            points.push(geom2);
                            break;
                        case gc.gis.geom.GCGeometryType.LINESTRING:
                        case gc.gis.geom.GCGeometryType.LINEARRING:
                            lines.push(geom2);
                            break;
                        case gc.gis.geom.GCGeometryType.POLYGON:
                            polygons.push(geom2);
                            break;
                    }
                }
                break;
            case gc.gis.geom.GCGeometryType.CIRCLE:
                // TODO
                break;
        }
    }

    if (points.length === 0 && lines.length === 0 && polygons.length === 0)
    {
        // TODO Exception
    }

    if (points.length > 0 && lines.length === 0 && polygons.length === 0)
    {
        if (points.length === 1)
        {
            return points[0];
        }

        geom = factory.createMultiPoint();
        // TODO
        return geom;
    }
    else if (points.length === 0 && lines.length > 0 && polygons.length === 0)
    {
        if (lines.length === 1)
        {
            return lines[0];
        }

        geom = factory.createMultiLineString();
        // TODO
        return geom;
    }
    else if (points.length === 0 && lines.length === 0 && polygons.length > 0)
    {
        if (polygons.length === 1)
        {
            return polygons[0];
        }

        geom = factory.createMultiPolygon();
        // TODO
        return geom;
    }

    geom = factory.createGeometryCollection();
    geom.setGeometries(points.concat(lines, polygons));
    return geom;
};